// Header with click events instead of hover for tablets
export default function initializeHeader() {
    const OPEN_CLASSNAME = 'tablet-click'

    const MenuContent = document.querySelector("div#menu_content");
    const jvscon = [...MenuContent.querySelectorAll("span.jvscon")];

    function closeAllOpenHeaders() {
        const openHeaderItems = [...document.querySelectorAll(`.${OPEN_CLASSNAME}`)]
        for (const openHeaderItem of openHeaderItems) {
            openHeaderItem.classList.remove(OPEN_CLASSNAME)
        }
    }

    for (const headerItem of jvscon) {
        if (!headerItem.querySelector('ul')) {
            continue
        }

        headerItem.addEventListener('click', function (event) {
            if (!this.classList.contains(OPEN_CLASSNAME)) {
                event.preventDefault()
                event.stopPropagation()
                
                closeAllOpenHeaders()
                this.classList.add(OPEN_CLASSNAME)
            }
        })
    }

    document.body.addEventListener('click', (event) => {
        let node = event.target
        while (node) {
            if (node.classList && node.classList.contains('jvscon')) {
                return
            }
            node = node.parentNode
        }

        closeAllOpenHeaders()
    })
}